import { useQuery } from '@tanstack/react-query';
import { http } from 'services/http';
import { TRANSPORT_LINES_STATISTICS_GET } from 'api/query-keys.ts';
import type { TStatisticTransportLineRes } from 'api/swagger';

export const useGetTransportLinesStatistics = () => {
  return useQuery<TStatisticTransportLineRes[]>({
    queryKey: [TRANSPORT_LINES_STATISTICS_GET],
    queryFn: async () => {
      const { data } = await http.get<TStatisticTransportLineRes[]>('/v1/statistics/transport-lines');
      return data;
    },
    retry: false,
    refetchOnWindowFocus: false,
  });
};
